
define('text!modules/image_picker/image_picker_template.html',[],function () { return '<div class="js-image-picker-content"></div>';});

